export default "__VITE_ASSET__T$pCfzST__"